var _g, _path, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPocketChest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 73,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 73.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 17.75,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.45,
    y: 19.45,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 13.75,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.45,
    y: 15.45,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 21.15,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.45,
    y: 22.75,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 24.45,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.45,
    y: 26.05,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 27.75,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.45,
    y: 29.45,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 31.05,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.45,
    y: 32.75,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 34.35,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.45,
    y: 36.05,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 37.65,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.45,
    y: 39.35,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 41.05,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.45,
    y: 42.65,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 44.35,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.45,
    y: 45.95,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 47.65,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.45,
    y: 49.25,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 50.95,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.45,
    y: 52.65,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 54.25,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.45,
    y: 55.95,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 57.55,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.45,
    y: 59.25,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 60.85,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.45,
    y: 62.55,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 64.25,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.45,
    y: 65.85,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 67.55,
    width: 1.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.45,
    y: 69.15,
    width: 1.7,
    height: 0.8
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.05,10.78V71.65h3.7V10.78ZM3.65,71V11.78h2.7V71Z",
    transform: "translate(-1 -0.4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7,73.25H3.05a1.79,1.79,0,0,1-1.8-1.8v-69A1.79,1.79,0,0,1,3.05.65H7a1.79,1.79,0,0,1,1.8,1.8v69A1.93,1.93,0,0,1,7,73.25Z",
    transform: "translate(-1 -0.4)",
    fill: "none",
    stroke: "#404041",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    style: {
      isolation: "isolate"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "zip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,9.33a2.69,2.69,0,0,1-2-.9,2.18,2.18,0,0,1-.57-1.72L3,2.46a.36.36,0,0,1,.36-.31H6.75a.35.35,0,0,1,.35.31l.49,4.25A2.14,2.14,0,0,1,7,8.43,2.71,2.71,0,0,1,5,9.33ZM3.66,2.86,3.2,6.79A1.49,1.49,0,0,0,3.59,8,2,2,0,0,0,5,8.61,2,2,0,0,0,6.5,8a1.48,1.48,0,0,0,.38-1.17L6.43,2.86Z",
    transform: "translate(-1 -0.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,8A1.43,1.43,0,0,1,4,7.46a1.13,1.13,0,0,1-.27-.92l.13-.75a.35.35,0,0,1,.35-.3H5.92a.35.35,0,0,1,.35.29l.13.76a1.1,1.1,0,0,1-.27.93A1.47,1.47,0,0,1,5,8ZM4.46,6.2l-.07.46a.4.4,0,0,0,.1.34A.74.74,0,0,0,5,7.26.77.77,0,0,0,5.59,7a.48.48,0,0,0,.11-.35L5.62,6.2Z",
    transform: "translate(-1 -0.4)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPocketChest);
export default __webpack_public_path__ + "static/media/pocket-chest.a277ebe83ae757e6f0f98524a70abbbb.svg";
export { ForwardRef as ReactComponent };